import React from 'react';


export default function FieldCRMContacts_Pill(props:any) {

    if (!props.option) return null;

    const {option}  = props

    const onClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        gd.navigation.goToCrmContact(props.option.value)
    }

    const onDelete = (e:React.SyntheticEvent) => {
        e.stopPropagation()

        if(props.onDelete) props.onDelete(props.option);
    }

    // p-r-15  - no margin because padding part of width ...
    // <div className="ui5-pill-u gray s-26 ui5-txt-less-important-small fl-ac p-r-15 field-item" style={props.style} onClick={onClick}>
    return (
        <div className="ui5-pill-u gray s-26 m-r-5" style={props.style} onClick={onClick}>
            <span className="ui5-ico-16 m-r-5 fl-no-shrink i5-crm-contact"/>
            <span className="txt-truncate">{option.label}</span>
            {props.onDelete && <div className="i5-close" onClick={onDelete} />}
        </div>
    )

}